import { Link } from "react-router-dom"


export const ExploreTopComics = () => {
    return (
        <div className='p-5 mb-4 bg-dark header'>
            <div className='container-fluid py-5 text-white d-flex justify-content-center align-items-center'>
                <div>
                    <h1 className='display-5 fw-bold comic-font'>THE MOST POPULAR COMICS OF THE SEASON</h1>
                    <Link type='button' className='btn btn-danger btn-lg text-white' to='/search'>Explore Top Comics</Link>
                </div>
            </div>
        </div>
    )
}